<template>
  <div class="jTabsa">
    <div
      id="tab-container"
      class="tab-content">
      <div
        v-for="item in tabs"
        :key="item.id"
        :id="item.idComp"
        :aria-labelledby="item.idTab"
        role="tabpanel"
        class="tab-pane">
        <component
          v-if="isLoadTab(item.idTab)"
          :is="item.comp"
          class="tab-component"/>
      </div>
    </div>
  </div>

</template>

<script>
export default {

  name: 'JTabs',
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      more: null,
      widthTabs: 0,
      greedy: {
        element: '.greedy-menu',
        counter: true,
      },
      element: null,
      counter: null,
      visibleLinks: null,
      toggleButton: null,
      breakpoints: null,
      openTab: this.tabs[0],
      oldTabId: null,
      oldPanelId: null,
      tabId: null,
      panelId: null,
      loadTabs: [],
    };
  },
  computed: {
    tabsShow() {
      return this.tabs.filter(i => i.isShow);
    },
  },
  mounted() {
    this.mGreedy(this.greedy);
    this.setUpMenu();
    this.calculateBreakPoints();
    this.updateMenu();
    this.addBindings();
    this.updateMenu();

    const tabs = this.tabs;
    let op = this.openTab;
    if (this.$router.currentRoute.hash) {
      for (let i = 0; i < tabs.length; i += 1) {
        if (`#${tabs[i].idTab}` === this.$router.currentRoute.hash) {
          op = tabs[i];
        }
      }
    }
    this.showTab(op);
  },
  updated() {
    this.mGreedy(this.greedy);
    this.setUpMenu();
    this.calculateBreakPoints();
    this.updateMenu();
    this.addBindings();
    this.updateMenu();
  },
  methods: {
    isLoadTab(idTab) {
      return this.loadTabs.includes(idTab);
    },
    mGreedy(options) {
      this.element = document.querySelector(options.element);
      this.counter = options.counter || false;
      this.visibleLinks = this.element.querySelector('ul');
      this.toggleButton = this.element.querySelector('.toggle-links');
      this.breakpoints = [];
    },
    setUpMenu() {
      this.hiddenLinks = document.createElement('ul');
      this.hiddenLinks.classList.add('hidden-links');
      this.hiddenLinks.classList.add('links-invisible');
      this.element.appendChild(this.hiddenLinks);
      this.visibleLinks.classList.add('visible-links');

      if (this.counter) {
        this.toggleButton.classList.add('counter');
      } else {
        this.toggleButton.classList.add('no-counter');
      }
    },
    calculateBreakPoints() {
      let childrenWidth = 0;

      for (let i = 0; i < this.visibleLinks.children.length; i += 1) {
        childrenWidth += this.visibleLinks.children[i].offsetWidth;
        this.breakpoints[i] = childrenWidth;
      }
    },

    addBindings() {
      window.addEventListener('resize', this.updateMenu);
      this.toggleButton.addEventListener('click', this.toggleHiddenLinks);
      document.addEventListener('click', this.closeToggle);
    },
    updateMenu() {
      const availableSpace = this.element.clientWidth - 50;
      let itemsVisible = this.visibleLinks.children.length;

      /*
                Check if there is not enough space for the visible links or
                if there is space available for the hidden link
                */
      if (availableSpace < this.breakpoints[itemsVisible - 1]) {
        this.toggleButton.classList.add('visible');

        while (availableSpace < this.breakpoints[itemsVisible - 1]) {
          this.hiddenLinks.insertBefore(this.visibleLinks.children[itemsVisible - 1],
            this.hiddenLinks.firstChild);
          itemsVisible -= 1;
        }
      } else if (availableSpace > this.breakpoints[itemsVisible]) {
        while (availableSpace > this.breakpoints[itemsVisible]) {
          this.visibleLinks.appendChild(this.hiddenLinks.removeChild(this.hiddenLinks.firstChild));
          itemsVisible += 1;
        }
      }

      if (this.counter) {
        this.toggleButton.setAttribute('data-count', this.hiddenLinks.children.length);
        if (!this.hiddenLinks.children.length) {
          this.toggleButton.classList.remove('visible');
        }
      }
    },
    toggleHiddenLinks() {
      this.hiddenLinks.classList.toggle('links-invisible');
      this.toggleButton.classList.toggle('links-displayed');
    },
    closeToggle(event) {
      // eslint-disable-next-line prefer-destructuring
      const hiddenLinks = this.hiddenLinks;
      // eslint-disable-next-line prefer-destructuring
      const toggleButton = this.toggleButton;
      if (event.target === toggleButton) {
        if (!hiddenLinks.classList.contains('links-invisible')) {
          if (!(toggleButton.classList.contains('links-displayed'))) {
            hiddenLinks.classList.remove('links-invisible');
            toggleButton.classList.add('links-displayed');
          }
        } else {
          hiddenLinks.classList.add('links-invisible');
          toggleButton.classList.remove('links-displayed');
        }
      } else if (event.target.className !== 'tabs') {
        if (!hiddenLinks.classList.contains('links-invisible')) {
          hiddenLinks.classList.toggle('links-invisible');
        }
        if (toggleButton.classList.contains('links-displayed')) {
          toggleButton.classList.toggle('links-displayed');
        }
      }
    },
    showTab(n) {
      this.loadTabs.push(n.idTab);

      if (!n.hrefout) {
        if (this.openTab !== undefined) {
          if (!this.openTab.hrefout) {
            this.oldTabId = document.querySelector(`#${this.openTab.idTab}`);
            this.oldPanelId = document.querySelector(`#${this.openTab.idComp}`);
            this.oldTabId.setAttribute('aria-selected', false);
            this.oldPanelId.setAttribute('aria-hidden', true);
          }
        }
        this.tabId = document.querySelector(`#${n.idTab}`);
        this.panelId = document.querySelector(`#${n.idComp}`);
        this.tabId.setAttribute('aria-selected', true);
        this.panelId.setAttribute('aria-hidden', false);

        this.openTab = n;
      } else {
        window.open(n.hrefout, '_self');
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tabs/jTabs.vue